// Market and opportunity section configuration
// Defines fields for market size, segments, and growth potential
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for market section
export const marketSectionSchema = z.object({
  targetMarketSize: z.string().min(1, 'Este campo es requerido'),
  initialSegment: z.array(z.string()).min(1, 'Al menos un segmento es requerido'),
  growthPotential: z.string().min(1, 'Este campo es requerido'),
  marketTrends: z.string().min(1, 'Este campo es requerido'),
});

export type MarketSectionData = z.infer<typeof marketSectionSchema>;

// Section config
export const marketSection: SectionConfig = {
  id: 'market',
  titleKey: 'Mercado y oportunidad',
  descriptionKey: 'Define el tamaño y potencial de tu mercado objetivo',
  validationSchema: marketSectionSchema,
  fields: [
    {
      name: 'targetMarketSize',
      type: 'radio',
      label: 'Tamaño del mercado objetivo',
      required: true,
      options: [
        { value: '1-10', label: '1-10' },
        { value: '10-30', label: '10-30' },
        { value: '30-50', label: '30-50' },
        { value: '50-100', label: '50-100' },
        { value: '100-500', label: '100-500' },
        { value: '500+', label: '+500' },
      ],
    },
    {
      name: 'initialSegment',
      type: 'multiselect',
      label: 'Segmento inicial de enfoque',
      required: true,
      options: [
        { value: 'end-consumers', label: 'Consumidores finales' },
        { value: 'small-business', label: 'Empresas pequeñas' },
        { value: 'medium-business', label: 'Empresas medianas' },
      ],
    },
    {
      name: 'growthPotential',
      type: 'radio',
      label: '¿Cuál es el potencial de crecimiento de tu startup en los próximos 12 meses?',
      required: true,
      options: [
        { value: 'low', label: 'Bajo (0-10% de crecimiento esperado)' },
        { value: 'medium', label: 'Medio (11-30%)' },
        { value: 'high', label: 'Alto (31-70%)' },
        { value: 'very-high', label: 'Muy alto (71-150%)' },
        { value: 'explosive', label: 'Explosivo (más de 150%)' },
      ],
    },
    {
      name: 'marketTrends',
      type: 'textarea',
      label: 'Principales tendencias del mercado',
      placeholder: 'Describe las tendencias relevantes...',
      required: true,
    },
  ],
};
